var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "conteneurLead",
      staticStyle: { width: "100%" },
      attrs: { flat: "", id: "conteneurLead" }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("justCloseDialogConfirm")
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "title tf_title_dialog",
            domProps: { innerHTML: _vm._s(_vm.titleDialogConfirm) }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-flex", { attrs: { xs12: "" } }, [
                _c("div", [_vm._v(_vm._s(_vm.buildEnhancementInstruction()))])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "mt-3", attrs: { xs12: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.computedActionUrl,
                      "item-text": "text",
                      "item-value": "id",
                      label: _vm.$t("promptselect")
                    },
                    model: {
                      value: _vm.selectActionPrompt,
                      callback: function($$v) {
                        _vm.selectActionPrompt = $$v
                      },
                      expression: "selectActionPrompt"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-textarea", {
                    attrs: {
                      value: _vm.getCurrentPromptValue(),
                      label: _vm.$t("promptcurrent"),
                      readonly: "",
                      "auto-grow": "",
                      rows: "8",
                      outline: ""
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-textarea", {
                    attrs: {
                      label: _vm.$t("promptadditional"),
                      "auto-grow": "",
                      rows: "8",
                      outline: ""
                    },
                    model: {
                      value: _vm.enhancementSystemPrompt,
                      callback: function($$v) {
                        _vm.enhancementSystemPrompt = $$v
                      },
                      expression: "enhancementSystemPrompt"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "" },
              on: {
                click: function($event) {
                  return _vm.closeDialogConfirm()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("close")))]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                loading: _vm.loadingEnhance,
                disabled: _vm.loadingEnhance || !_vm.selectedPromptField()
              },
              on: { click: _vm.enhancePromptWithAI }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("promptameliore")) + "\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "90%" },
          model: {
            value: _vm.showDialogComparePrompt,
            callback: function($$v) {
              _vm.showDialogComparePrompt = $$v
            },
            expression: "showDialogComparePrompt"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text compare-title" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.closeCompareDialog }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "title compare-title-text" }, [
                    _vm._v(_vm._s(_vm.$t("promptcompare")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "compare-body" },
                [
                  _c(
                    "v-layout",
                    { staticClass: "mb-2", attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "pr-3 compare-top-cell",
                          attrs: { xs12: "", md6: "" }
                        },
                        [
                          _c("div", { staticClass: "compare-top-title" }, [
                            _c("strong", [_vm._v(_vm._s(_vm.$t("Section")))]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedPromptLabel()) +
                                "\n            "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass:
                            "pl-3 compare-top-cell compare-top-cell-right",
                          attrs: { xs12: "", md6: "" }
                        },
                        [
                          _c("div", { staticClass: "compare-top-title" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("promptameliored")) +
                                " (" +
                                _vm._s(_vm.enhancedVariants.length) +
                                ")\n            "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "pr-3 compare-col compare-col-panel",
                          attrs: { xs12: "", md6: "" }
                        },
                        [
                          _c("h3", { staticClass: "mb-2 compare-label" }, [
                            _vm._v(_vm._s(_vm.$t("promptactual")))
                          ]),
                          _vm._v(" "),
                          _c("v-textarea", {
                            staticClass: "compare-main-textarea",
                            attrs: {
                              value: _vm.getCurrentPromptValue(),
                              readonly: "",
                              "auto-grow": "",
                              rows: "12",
                              outline: ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "pl-3 compare-col compare-col-panel",
                          attrs: { xs12: "", md6: "" }
                        },
                        [
                          _vm.enhancedVariants.length
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "mb-3 pa-2 variant-selected",
                                  attrs: { flat: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between align-center mb-1"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "Version " +
                                            _vm._s(_vm.selectedVariantIndex + 1)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.selectedVariantIndex + 1) +
                                            " / " +
                                            _vm._s(_vm.enhancedVariants.length)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    staticClass: "compare-variant-textarea",
                                    attrs: {
                                      value: _vm.selectedEnhancedPrompt(),
                                      "auto-grow": "",
                                      rows: "6",
                                      outline: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.setSelectedVariantContent(
                                          $event
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex justify-end" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            flat: "",
                                            color: "primary",
                                            disabled:
                                              _vm.selectedVariantIndex <= 0
                                          },
                                          on: { click: _vm.showPreviousVariant }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Précédente\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary",
                                            disabled:
                                              _vm.selectedVariantIndex >=
                                              _vm.enhancedVariants.length - 1
                                          },
                                          on: { click: _vm.showNextVariant }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Variante\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", { staticClass: "my-3" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "iteration-title" },
                                    [_vm._v("Itérations sur cette version")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      ref: "iterationThread",
                                      staticClass: "iteration-thread"
                                    },
                                    _vm._l(_vm.iterationMessages, function(
                                      msg,
                                      idx
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: "iter-msg-" + idx,
                                          staticClass: "iteration-message",
                                          class:
                                            msg.role === "user"
                                              ? "iteration-message--user"
                                              : "iteration-message--assistant"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                msg.role === "user"
                                                  ? "Vous"
                                                  : "IA"
                                              ) + " :"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(msg.content))
                                          ])
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      label: "Instruction supplémentaire",
                                      placeholder:
                                        "Ex: rends le plus concis, ajoute des contraintes sur le ton...",
                                      "auto-grow": "",
                                      rows: "3",
                                      outline: ""
                                    },
                                    on: {
                                      keydown: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        if (
                                          $event.ctrlKey ||
                                          $event.shiftKey ||
                                          $event.altKey ||
                                          $event.metaKey
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.iterateEnhancedPrompt.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.iterationInput,
                                      callback: function($$v) {
                                        _vm.iterationInput = $$v
                                      },
                                      expression: "iterationInput"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex justify-end" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary",
                                            loading: _vm.loadingIterate,
                                            disabled:
                                              _vm.loadingIterate ||
                                              !_vm.iterationInput.trim()
                                                .length ||
                                              !_vm.selectedEnhancedPrompt()
                                                .length
                                          },
                                          on: {
                                            click: _vm.iterateEnhancedPrompt
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Envoyer\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: { click: _vm.closeCompareDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("close")))]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#001B39",
                        dark: "",
                        disabled:
                          !_vm.selectedEnhancedPrompt().length ||
                          !_vm.selectedPromptField()
                      },
                      on: { click: _vm.openConfirmApplyDialog }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("promptapply")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "560" },
          model: {
            value: _vm.showDialogConfirmApply,
            callback: function($$v) {
              _vm.showDialogConfirmApply = $$v
            },
            expression: "showDialogConfirmApply"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.$t("promptconfirm")))
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v("\n        " + _vm._s(_vm.$t("promptvalid1"))),
                _c("strong", [_vm._v(_vm._s(_vm.selectedPromptLabel()))]),
                _vm._v(_vm._s(_vm.$t("promptvalid2")) + "\n        "),
                _c("br"),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("promptcontinue")) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogConfirmApply = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "#001B39", dark: "" },
                      on: { click: _vm.confirmApplyEnhancedPrompt }
                    },
                    [_vm._v(_vm._s(_vm.$t("confirm")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28c02b74", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28c02b74","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzDialogEnhancePrompt.vue
// module id = null
// module chunks = 